import React from 'react';
import './Telecom.css'; // Make sure this file exists

const Telecom = () => {
  return (
    <div className="telecom-container">
      <section className="section property-management">
        <img src="/images/telecom.png" alt="Property Management" className="section-img" />
        <h2>Property Management Solution</h2>

        <h4>The Problem</h4>
        <p>
          Absence of a comprehensive digital system that would help keep track of and optimally use a wide variety of assets and their data.
        </p>

        <h4>Challenge</h4>
        <p>
          Valuable assets and associated data formed an extremely complex maze as the client’s business grew. Without a highly sophisticated software application that was both powerful and yet simple, the client’s profitability and productivity was being hurt.
        </p>

        <h4>Objectives</h4>
        <ul>
          <li>Provide centralized software to track network roll-outs and maintenance.</li>
          <li>Manage diverse assets from acquisition to decommissioning.</li>
          <li>Ensure seamless integration into existing IT ecosystem.</li>
        </ul>

        <h4>Solution</h4>
        <p>
          We conducted an in-depth analysis of the client's needs, mapped their operating environment, and deployed the Siterra application for Property Management. This centralized solution optimized workflows, reduced project timelines, and enabled agile, accurate decision-making.
        </p>
      </section>

      <section className="section oss-bss">
        <img src="/images/telecom2.png" alt="OSS/BSS" className="section-img" />
        <h2>OSS/BSS</h2>

        <h4>Problem</h4>
        <p>
          Customer wanted to implement a single platform for OSS & BSS.
        </p>

        <h4>Solution</h4>
        <p>
          OSS & BSS were unified in one platform featuring floor plans, rack elevations, shelf view & slot occupation, graphical device representation, physical ports, SFPs, and color-coded cables.
        </p>
      </section>

      <section className="section asset-vaantage">
        <img src="/images/telecom3.png" alt="AssetVaantage" className="section-img" />
        <h2>AssetVaantage</h2>

        <h4>Project Name</h4>
        <p>Asset Management System</p>

        <h4>Client</h4>
        <p>A telecom subsidiary of a giant utility company.</p>

        <h4>Our Role</h4>
        <p>
          The client is responsible for Fibre-to-Home service. As their asset size grew, Inovaantage was brought in to implement our in-house solution, AssetVaantage. This system tracks assets, enables proactive maintenance, and supports emergency preparedness. It's now used company-wide for all asset management needs.
        </p>
      </section>
    </div>
  );
};

export default Telecom;
